import { CountriesEnumList } from '../enums/countries.enum';

export const ICON_PATH_COUNTRIES: Record<CountriesEnumList, string> = {
  [CountriesEnumList.AUSTRIA]: '../assets/icons/countries.svg#austria',
  [CountriesEnumList.BELGIUM]: '../assets/icons/countries.svg#belgium',
  [CountriesEnumList.BULGARIA]: '../assets/icons/countries.svg#bulgaria',
  [CountriesEnumList.CYPRUS]: '../assets/icons/countries.svg#cyprus',
  [CountriesEnumList.CROATIA]: '../assets/icons/countries.svg#croatia',
  [CountriesEnumList.CZECH_REPUBLIC]: '../assets/icons/countries.svg#czech_republic',
  [CountriesEnumList.DENMARK]: '../assets/icons/countries.svg#denmark',
  [CountriesEnumList.ESTONIA]: '../assets/icons/countries.svg#estonia',
  [CountriesEnumList.FINLAND]: '../assets/icons/countries.svg#finland',
  [CountriesEnumList.FRANCE]: '../assets/icons/countries.svg#france',
  [CountriesEnumList.GERMANY]: '../assets/icons/countries.svg#germany',
  [CountriesEnumList.GREECE]: '../assets/icons/countries.svg#greece',
  [CountriesEnumList.HUNGARY]: '../assets/icons/countries.svg#hungary',
  [CountriesEnumList.IRELAND]: '../assets/icons/countries.svg#ireland',
  [CountriesEnumList.ITALY]: '../assets/icons/countries.svg#italy',
  [CountriesEnumList.LATVIA]: '../assets/icons/countries.svg#latvia',
  [CountriesEnumList.LITHUANIA]: '../assets/icons/countries.svg#lithuania',
  [CountriesEnumList.LUXEMBOURG]: '../assets/icons/countries.svg#luxembourg',
  [CountriesEnumList.MALTA]: '../assets/icons/countries.svg#malta',
  [CountriesEnumList.NETHERLANDS]: '../assets/icons/countries.svg#netherlands',
  [CountriesEnumList.POLAND]: '../assets/icons/countries.svg#poland',
  [CountriesEnumList.PORTUGAL]: '../assets/icons/countries.svg#portugal',
  [CountriesEnumList.ROMANIA]: '../assets/icons/countries.svg#romania',
  [CountriesEnumList.SLOVAKIA]: '../assets/icons/countries.svg#slovakia',
  [CountriesEnumList.SLOVENIA]: '../assets/icons/countries.svg#slovenia',
  [CountriesEnumList.SPAIN]: '../assets/icons/countries.svg#spain',
  [CountriesEnumList.SWEDEN]: '../assets/icons/countries.svg#sweden',
};

export const PHONE_PREFIX_FOR_CYPRUS = '2';
export const PHONE_MASK_FOR_CYPRUS = '0 000000';
export const ZIP_MASK_FOR_LATVIA = '0000';
export const ZIP_MASK_FOR_LITHUANIA = '00000';
export const ZIP_PREFIX_FOR_LATVIA = 'LV-';
export const ZIP_PREFIX_FOR_LITHUANIA = 'LT-';
export const DEFAULT_PHONE_MASK = '000 0000000';
export const DEFAULT_ZIP_MASK = '0000';
export const DEFAULT_COUNTRY = 'Austria';
